import { Component, EventEmitter, Injector, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AbstractComponent } from 'lib-trend-core';
import { Constants } from '../../../../environments/constantes';
import { MOBILE_APP_MODAL_CONFIG, MobileAppModalComponent } from '../mobile-app-modal/mobile-app-modal.component';

/** At or below this width the sidebar is an off-canvas drawer (mirrors SideBarComponent.closeSidebar). */
const OFF_CANVAS_MAX_WIDTH = 768;

/**
 * Sidebar help-box advertising the Trendmulti native app (iOS + Android).
 * Clicking anywhere on the card opens the device picker. The × hides it until the
 * next login — the login flows clear Constants.mobileAppPromoDismissed.
 */
@Component({
  selector: 'mobile-app-promo',
  templateUrl: './mobile-app-promo.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MobileAppPromoComponent extends AbstractComponent implements OnInit {

  /** Emitted right before the modal opens, so the sidebar can close its off-canvas drawer. */
  @Output() opened = new EventEmitter<void>();

  visible = false;

  constructor(
    injector: Injector,
    private readonly dialog: MatDialog,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.visible = !this.readDismissal();
  }

  openModal(): void {
    this.opened.emit();
    this.dialog.open(MobileAppModalComponent, {
      ...MOBILE_APP_MODAL_CONFIG,
      // On small screens the drawer has just closed; restoring focus there would land on hidden content.
      restoreFocus: window.innerWidth > OFF_CANVAS_MAX_WIDTH,
    });
  }

  dismiss(): void {
    this.visible = false;
    try {
      localStorage.setItem(Constants.mobileAppPromoDismissed, new Date().toISOString());
    } catch {
      // Storage blocked (private mode): the card stays hidden for this page view only.
    }
  }

  private readDismissal(): string | null {
    try {
      return localStorage.getItem(Constants.mobileAppPromoDismissed);
    } catch {
      return null;
    }
  }

}
